module.exports = __webpack_public_path__ + "img/beer_id-60.d7ef3879.png";